import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { mapProps } from 'recompose';

import { getAsset } from '../../../../../../../../../util/assets';
import Button from '../../../../../../../../../components/global/Button';
import Badge from '../../../../../../../../../components/global/Badge';
import withModal from '../../../../../../../../../components/global/modal/withModal';

const propTypes = {
  className: PropTypes.string,
  printPackageItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onPhotoSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const PriceTagPhotoUpsellModal = ({
  className,
  onPhotoSelect,
  onClose,
  printPackageItem,
}) => {
  const classes = classNames({
    'price-tag-photo-upsell-modal-content': true,
    [className]: !!className,
  });
  const albumFolderTag = printPackageItem.album_folder_tag;
  const price = printPackageItem.price?.value ?? 0;
  const discountPrice = printPackageItem.discount_price?.value ?? 0;
  const hasDiscount = !!discountPrice && discountPrice < price;
  const discountPercentage = (((price - discountPrice) / price) * 100).toFixed(
    2,
  );

  return (
    <div className={classes}>
      <img src={getAsset('/icon-package-3d.svg')} alt="" className="mb-2" />
      <Badge
        className="purchasing-option-item-info-extra-tag mb-3"
        badgeSize="sm"
        badgeStyle="purple"
      >
        {albumFolderTag.name}
      </Badge>

      <p className="text-dark text-extra-bold text-md lh-normal mb-4">
        {hasDiscount ? (
          <Fragment>
            Save {discountPercentage}% off your {albumFolderTag.name} print when
            you check out with a Photo Package!
          </Fragment>
        ) : (
          <Fragment>
            Add a {albumFolderTag.name} print to your Photo Package!
          </Fragment>
        )}
      </p>

      <div className="text-center">
        <Button onClick={onPhotoSelect} btnBlock className="px-4">
          Pick a {albumFolderTag.name}
        </Button>
        <Button onClick={onClose} btnStyle="link" className="mt-2">
          Maybe Later
        </Button>
      </div>
    </div>
  );
};

PriceTagPhotoUpsellModal.propTypes = propTypes;

export const PRICE_TAG_PHOTO_UPSELL_MODAL = 'PRICE_TAG_PHOTO_UPSELL_MODAL';

export default withModal(
  mapProps(({ onRequestClose, actionProps = {}, ...props }) => ({
    onClose: onRequestClose,
    ...actionProps,
    ...props,
  }))(PriceTagPhotoUpsellModal),
  {
    name: PRICE_TAG_PHOTO_UPSELL_MODAL,
    size: 'xs',
    hideHeader: true,
  },
);
